import React, {Component} from 'react';
import Registry from "../../../../Utils/Registry";
import Helpers from "../../../../Utils/Helpers";


class EnterpriseInvoicesV2TableLine extends Component {
    constructor(props) {
        super(props);

        this.api = Registry.registered("api");

        this.state = {
            actions_toggled: false,
            dropDownOpen: false
        };
    }

    getQtyCell = () => {
        let volByUnit = {};
        const { sections, number } = this.props.invoice;

        sections.forEach(({rows}) => rows.forEach(({quantity, reference, unit}) => {
            if(reference && reference.startsWith("FUEL-")) {
                if(volByUnit[unit] === undefined)
                    volByUnit[unit] = 0;
                volByUnit[unit] += parseFloat(quantity);
            }
        }));

        if(!Object.keys(volByUnit).length)
            return "/";

        return Object.keys(volByUnit)
            .map(unit => <span key={`${number}-${unit}`}>{volByUnit[unit].toFixed(2)} {unit}</span>)
            .reduce((prev, curr) => [prev, ' | ', curr]);
    };

    render() {
        const { invoice, downloadInvoice } = this.props;

        return (
            <tr className={"no-click " + (invoice.paid === 3 ? " default-payment" : "")}>
                <td className="wp-10">
                    { invoice.number }
                </td>
                <td className="wp-10 vertical-align-middle">{invoice.createdAt === null ? "" : Helpers.formatDate(invoice.createdAt, "DD/MM/YY")}</td>
                <td className="w-15 vertical-align-middle">{this.getQtyCell()}</td>
                <td className="w-15 vertical-align-middle">{invoice.totalExcludingTaxes} &euro;</td>
                <td className="w-15 vertical-align-middle ">{invoice.totalWithTaxes} &euro;</td>
                <td className="vertical-align-middle">
                    {invoice.paymentStatus === "not-paid" ? <i className="icon icon-close f-14 blue-dark tooltip-info-status" aria-hidden="true"><span className="tooltip-info-status-text">Non pay&eacute;</span></i> : "" }
                    {invoice.paymentStatus === "paid" ? <i className="icon icon-check f-14 green tooltip-info-status" aria-hidden="true"><span className="tooltip-info-status-text">Pay&eacute;</span></i> : "" }
                    {invoice.paymentStatus === "cancelled" ? <i className="icon icon-cash-remove f-14 red tooltip-info-status" aria-hidden="true"><span className="tooltip-info-status-text">Annulée</span></i> : "" }
                
                </td>
                <td className="_w-50 vertical-align-middle" onClick={e => e.stopPropagation()}>
                    <i className="icon icon-file no-bold f-18 pointer" onClick={downloadInvoice} />
                </td>
            </tr>
        )
    }
}

EnterpriseInvoicesV2TableLine.defaultProps = {
    invoice: {},
	downloadInvoice: () => {}
};

export default EnterpriseInvoicesV2TableLine;



// WEBPACK FOOTER //
// ./src/components/Enterprise/Invoices/Table/LineV2.js